import { useAuth0 } from "@auth0/auth0-react";

export const useAuthRoles = () => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  const userRoles = user?.roles || user?.['ponts/roles'] || [];
  
  const hasAdminRole = userRoles.includes('invirtus_admin');
  const isAdmin = isAuthenticated && hasAdminRole;
  
  return {
    isAuthenticated,
    isLoading: isLoading,
    isAdmin,
  };
};